export enum TableFontSize {
  Default = 'default',
  Middle = 'middle',
  Small = 'small',
}
